import { v4 as uuid } from 'uuid'

interface ImageMeasurementType {
  measurementUuid: uuid
  annotationUuid: uuid
  points: Array<Array<number>>
  length: number
  lengthUnits: string
  lengthUncertainty: string
  isPending: boolean
  isDeleting: boolean
}

class ImageMeasurement implements ImageMeasurementType {
  measurementUuid: uuid
  annotationUuid: uuid
  points: Array<Array<number>>
  length: number
  lengthUnits: string
  lengthUncertainty: string
  isPending: boolean
  isDeleting: boolean

  constructor(measurementUuid, annotationUuid, points, length, lengthUnits, lengthUncertainty) {
    this.measurementUuid = measurementUuid
    this.annotationUuid = annotationUuid
    this.points = points
    this.length = length
    this.lengthUnits = lengthUnits
    this.lengthUncertainty = lengthUncertainty
    this.isPending = false
    this.isDeleting = false
  }
}

type ImageMeasurements = Array<ImageMeasurementType>

export { ImageMeasurement }
export type { ImageMeasurementType, ImageMeasurements }
